import { Component, input, model, ChangeDetectionStrategy, signal, computed, effect } from '@angular/core';

import { PanelModule } from 'primeng/panel';

@Component({
  selector: 'app-collapsible-panel',
  standalone: true,
  imports: [PanelModule],
  templateUrl: './collapsible-panel.component.html',
  styleUrls: ['./collapsible-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsiblePanelComponent {
  // Required signal inputs
  header = input.required<string>();
  
  // Optional signal inputs
  id = input<string>();
  initialCollapsed = input<boolean>(true);
  
  // Optional two-way binding - allows external control
  collapsed = model<boolean>();
  
  // Internal state when no external control is provided
  private internalCollapsed = signal<boolean>(true);
  
  // Computed property that uses external control if provided, otherwise internal state
  actualCollapsed = computed(() => {
    const externalValue = this.collapsed();
    return externalValue !== undefined ? externalValue : this.internalCollapsed();
  });
  
  constructor() {
    // Initialize internal state with initialCollapsed value
    effect(() => {
      const initial = this.initialCollapsed();
      this.internalCollapsed.set(initial);
    }, { allowSignalWrites: true });
  }
  
  // Method to toggle collapsed state
  toggle() {
    if (this.collapsed() !== undefined) {
      // If external control is provided, update it
      this.collapsed.set(!this.collapsed());
    } else {
      // Otherwise, update internal state
      this.internalCollapsed.set(!this.internalCollapsed());
    }
  }
}